import * as React from "react";
import { forwardRef } from "react";
const SvgIcZoomMinus24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "iconZoomMinus 25" }, /* @__PURE__ */ React.createElement("rect", { id: "Vector", x: 2, y: 11, width: 20, height: 2, fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcZoomMinus24);
export { ForwardRef as ReactComponent };
